import { render, staticRenderFns } from "./EvoV2.vue?vue&type=template&id=a629e28a&"
import script from "./EvoV2.vue?vue&type=script&lang=js&"
export * from "./EvoV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports